import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { useBannerStore } from "@/store/banner/banner.state";
import Banner from "./Banner.vue";
import { IContentBanner } from "@/interfaces/self-service/content-banner.js";

export interface BannerListProps {
    banners?: IContentBanner[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BannnerList',
  props: {
    banners: {}
  },
  setup(__props: any) {



const state = useBannerStore();

const visible = computed(() => state.showSelfServicePolicyBanners);


return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.banners, (banner, index) => {
        return (_openBlock(), _createBlock(Banner, {
          key: index,
          testId: banner.testId,
          content: banner.content,
          ctaLabel: banner.ctaLabel,
          ctaLink: banner.ctaLink,
          collapsed: banner.collapsed
        }, null, 8, ["testId", "content", "ctaLabel", "ctaLink", "collapsed"]))
      }), 128))
    : _createCommentVNode("", true)
}
}

})